{
  "about.blocks": "ထိန်းချုပ်မှုရှိသော ဆာဗာများ",
  "about.contact": "ဆက်သွယ်ရန်:",
  "about.disclaimer": "Mastodon သည် အခမဲ့ဖြစ်ပြီး open-source software နှင့် Mastodon gGmbH ၏ ကုန်အမှတ်တံဆိပ်တစ်ခုဖြစ်သည်။.",
  "about.domain_blocks.no_reason_available": "အကြောင်းပြချက်မရှိပါ",
  "about.domain_blocks.preamble": "Mastodon သည် ယေဘုယျအားဖြင့် fediverse ရှိ အခြား​ဆာဗာ အသုံးပြုသူများထံမှ အကြောင်းအရာများကို ကြည့်ရှုနိုင်သည့်အပြင် အပြန်အလှန်တုံ့ပြန်နိုင်စေပါသည်။ ဤသည်တို့မှာ သီးခြားဆာဗာများအတွက် ပြုလုပ်ထားသောအရာများဖြစ်သည်။",
  "about.domain_blocks.silenced.explanation": "ရှင်းရှင်းလင်းလင်း ရှာကြည့်ခြင်း သို့မဟုတ် လိုက်ကြည့်ခြင်းဖြင့် ၎င်းကို ရွေးချယ်ခြင်းမှလွဲ၍ ဤဆာဗာမှ ပရိုဖိုင်များနှင့် အကြောင်းအရာများကို ယေဘုယျအားဖြင့် သင်သည် မမြင်ရပါ။",
  "about.domain_blocks.silenced.title": "ကန့်သတ်ထားသော",
  "about.domain_blocks.suspended.explanation": "ဤဆာဗာမှ ဒေတာများကို စီမံဆောင်ရွက်ခြင်း၊ သိမ်းဆည်းခြင်း သို့မဟုတ် ဖလှယ်ခြင်း မပြုဘဲ၊ ဤဆာဗာမှ အသုံးပြုသူများနှင့် အပြန်အလှန် ဆက်သွယ်မှု သို့မဟုတ် ဆက်သွယ်မှုတို့ကို မဖြစ်နိုင်အောင် ပြုလုပ်ပေးမည်မဟုတ်ပါ။",
  "about.domain_blocks.suspended.title": "ရပ်ဆိုင်းထားသည်။",
  "about.not_available": "ဤအချက်အလက်ကို ဤဆာဗာတွင် မရရှိနိုင်ပါ။",
  "about.powered_by": "{mastodon} မှ ဗဟိုချုပ်ကိုင်မှုလျှော့ချထားသော ဆိုရှယ်မီဒီယာ",
  "about.rules": "ဆာဗာစည်းမျဉ်းများ",
  "account.add_or_remove_from_list": "စာရင်းများမှ ထည့်ပါ သို့မဟုတ် ဖယ်ရှားပါ။",
  "account.badges.bot": "စက်ရုပ်",
  "account.badges.group": "အဖွဲ့",
  "account.block": "@{name} ကိုဘလော့မည်",
  "account.block_domain": " {domain} ဒိုမိန်းကိုပိတ်မည်",
  "account.block_short": "ပိတ်ဆို့",
  "account.blocked": "ဘလော့ထားသည်",
  "account.cancel_follow_request": "စောင့်ကြည့်မှု ပယ်ဖျက်ခြင်း",
  "account.copy": "လင့်ခ်ကို ပရိုဖိုင်သို့ ကူးယူပါ",
  "account.direct": "@{name} သီးသန့် သိရှိနိုင်အောင် မန်းရှင်းခေါ်မည်",
  "account.disable_notifications": "@{name} ပို့စ်တင်သည့်အခါ ကျွန်ုပ်ထံ အသိပေးခြင်း မပြုလုပ်ရန်။",
  "account.edit_profile": "ကိုယ်ရေးမှတ်တမ်းပြင်ဆင်မည်",
  "account.enable_notifications": "@{name} ပို့စ်တင်သည့်အခါ ကျွန်ုပ်ကို အကြောင်းကြားပါ။",
  "account.endorse": "အကောင့်ပရိုဖိုင်တွင်ဖော်ပြပါ",
  "account.follow": "စောင့်ကြည့်",
  "account.followers": "စောင့်ကြည့်သူများ",
  "account.followers.empty": "ဤသူကို စောင့်ကြည့်သူ မရှိသေးပါ။",
  "account.following": "စောင့်ကြည့်နေသည်",
  "account.follows.empty": "ဤသူသည် မည်သူ့ကိုမျှ စောင့်ကြည့်ခြင်း မရှိသေးပါ။",
  "account.go_to_profile": "ပရိုဖိုင်းသို့ သွားရန်",
  "account.hide_reblogs": "@{name} ၏ မျှဝေမှုကို ဝှက်ထားရန်",
  "account.in_memoriam": "အမှတ်တရ",
  "account.joined_short": "ပူးပေါင်း",
  "account.languages": "ဘာသာစကားပြောင်းမည်",
  "account.link_verified_on": "ဤလင့်ခ်၏ ပိုင်ဆိုင်မှုကို {date} က စစ်ဆေးခဲ့သည်။",
  "account.locked_info": "အကောင့်ကိုယ်ရေးကိုယ်တာကိုလော့ချထားသည်။အကောင့်ပိုင်ရှင်မှ ခွင့်ပြုချက်လိုအပ်သည်။",
  "account.media": "မီဒီယာ",
  "account.mention": "{name} ကိုမန်းရှင်းထားသည်",
  "account.moved_to": "{name} ၏အကောင့်အသစ်မှာ",
  "account.mute": "{name}ကိုပိတ်ထားရန်",
  "account.mute_notifications_short": "အကြောင်းကြားချက်များကို အသံပိတ်ထားရန်",
  "account.mute_short": "ပိတ်ထားရန်",
  "account.muted": "ပိတ်ထားရန်",
  "account.no_bio": "ဖော်ပြချက် မပေးထားပါ။",
  "account.open_original_page": "မူလစာမျက်နှာကိုဖွင့်ပါ",
  "account.posts": "ပို့စ်များ",
  "account.report": "တိုင်ကြားမည်{name}",
  "account.requested_follow": "{name} က သင့်ကို စောင့်ကြည့်ရန် တောင်းဆိုထားသည်",
  "account.share": "{name}၏ပရိုဖိုင်ကိုမျှဝေပါ",
  "account.show_reblogs": "@{name} မှ မျှ၀ေမှုများကို ပြပါ\n",
  "account.unblock": "{name} ကို ဘလော့ဖြုတ်မည်",
  "account.unblock_domain": " {domain} ဒိုမိန်းကိုပြန်ဖွင့်မည်",
  "account.unblock_short": "ဘလော့ဖြုတ်ရန်",
  "account.unendorse": "အကောင့်ပရိုဖိုင်တွင်မဖော်ပြပါ",
  "account.unfollow": "စောင့်ကြည့်ခြင်းအား ပယ်ဖျက်မည်",
  "account.unmute": "{name} ကို ပြန်ဖွင့်ရန်",
  "account.unmute_notifications_short": "အကြောင်းကြားချက်များကို ဖွင့်ထားရန်",
  "account.unmute_short": "ပြန်ဖွင့်ရန်",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.daily_retention": "အကောင့်ဖွင့်ပြီးနောက် တစ်ရက်ပြီးတစ်ရက် အသုံးပြုသူ ထိန်းသိမ်းမှုနှုန်း",
  "admin.dashboard.monthly_retention": "အကောင့်ဖွင့်ပြီးနောက် တစ်လအလိုက် အသုံးပြုသူ ထိန်းသိမ်းမှုနှုန်း",
  "admin.dashboard.retention.average": "ပျမ်းမျှ",
  "admin.dashboard.retention.cohort": "အကောင့်ပြုလုပ်မှုလ",
  "admin.dashboard.retention.cohort_size": "အသုံးပြုသူအသစ်များ",
  "admin.impact_report.instance_accounts": "အကောင့်ပရိုဖိုင်များကို ဖျက်မည်",
  "admin.impact_report.instance_followers": "စောင့်ကြည့်သူများ ကျွန်ုပ်တို့၏ အသုံးပြုသူများမှာ ဆုံးရှုံးနိုင်ပါမည်",
  "admin.impact_report.instance_follows": "စောင့်ကြည့်သူများမှာ သူတို့၏အသုံးပြုသူများ ဆုံးရှုံးနိုင်ပါမည်",
  "admin.impact_report.title": "ထိခိုက်မှုအကျဉ်းချုပ်",
  "alert.rate_limited.message": " {retry_time, time, medium}ပြီးနောက် ထပ်စမ်းကြည့်ပါ",
  "alert.rate_limited.title": "နှုန်းထားကန့်သတ်ထားသည်။\n",
  "alert.unexpected.message": "မမျှော်လင့်ထားသော အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်။",
  "alert.unexpected.title": "အယ်!",
  "announcement.announcement": "ကြေငြာချက်",
  "attachments_list.unprocessed": "(မလုပ်ဆောင်ရသေး)",
  "audio.hide": "အသံပိတ်မည်",
  "boost_modal.combo": "ဤအရာကို နောက်တစ်ကြိမ်ကျော်ရန် {combo} ကိုနှိပ်နိုင်သည်။",
  "bundle_column_error.copy_stacktrace": "စာကူးရာတွင်ပြဿနာရှိသည်",
  "bundle_column_error.error.body": "ဤစာမျက်နှာကို ဖော်ပြရာတွင် ပြဿနာရှိနေသည်",
  "bundle_column_error.error.title": "မှားနေသည်",
  "bundle_column_error.network.body": "ဒီစာမျက်နှာအား ဖွင့်လို့မရပါ။ အင်တာနက်ကွန်နက်ရှင် (သို့) ဆာဗာ ပြဿနာဖြစ်နေသည်။",
  "bundle_column_error.network.title": "အင်တာနက်ကွန်ယက် ပြဿနာ",
  "bundle_column_error.retry": "ထပ်ကြိုးစားပါ",
  "bundle_column_error.return": "Homeကိုပြန်သွားမည်",
  "bundle_column_error.routing.body": "ရှာနေသောအရာမှာမရှိပါ။ URL မှန်မမှန်ပြန်စစ်ပေးပါ",
  "bundle_column_error.routing.title": "လေးသုံညလေး",
  "bundle_modal_error.close": "ပိတ်ပါ",
  "bundle_modal_error.retry": "ထပ်မံကြိုးစားပါ",
  "closed_registrations.other_server_instructions": "Mastodon ကို ဗဟိုချုပ်ကိုင်မှု လျှော့ချထားသောကြောင့် သင်သည် အခြားဆာဗာတစ်ခုပေါ်တွင် အကောင့်တစ်ခု ဖန်တီးနိုင်ပြီး ဤတစ်ခုနှင့် အပြန်အလှန် တုံ့ပြန်ဆဲဖြစ်သည်။",
  "closed_registrations_modal.description": "{domain} တွင် အကောင့်တစ်ခုဖန်တီးခြင်းသည် လောလောဆယ်မဖြစ်နိုင်ပါ၊ သို့သော် Mastodon ကိုအသုံးပြုရန်အတွက် သင်သည် {domain} တွင် အထူးအကောင့်တစ်ခုမလိုအပ်ကြောင်း ကျေးဇူးပြု၍ သတိရပါ။",
  "closed_registrations_modal.find_another_server": "အခြားဆာဗာကိုရှာပါ။",
  "closed_registrations_modal.preamble": "Mastodon ကို ဗဟိုချုပ်ကိုင်မှု လျှော့ချထားသောကြောင့် သင့်အကောင့်ကို မည်သည့်နေရာတွင်ပင် ဖန်တီးပါစေ၊ သင်သည် ဤဆာဗာပေါ်ရှိ မည်သူမဆိုနှင့် လိုက်လျောညီထွေ တုံ့ပြန်နိုင်မည်ဖြစ်သည်။ သင်ကိုယ်တိုင်ပင် လက်ခံဆောင်ရွက်ပေးနိုင်သည်။",
  "closed_registrations_modal.title": "Mastodon တွင်အကောင့်ပြုလုပ်ပါ။\n",
  "column.about": "အကြောင်း",
  "column.blocks": "ဘလော့ထားသောအကောင့်များ",
  "column.bookmarks": "မှတ်တမ်းများ",
  "column.community": "ဒေသတွင်း အချိန်ဇယား",
  "column.direct": "သီးသန့်ဖော်ပြခြင်း",
  "column.directory": "ပရိုဖိုင်များကို ရှာဖွေမည်\n",
  "column.domain_blocks": "  ဒိုမိန်းကိုပိတ်မည်",
  "column.favourites": "Favorites",
  "column.firehose": "တိုက်ရိုက်ထုတ်လွှင့်မှုများ",
  "column.follow_requests": "စောင့်ကြည့်ရန် တောင်းဆိုမှုများ",
  "column.home": "ပင်မစာမျက်နှာ",
  "column.lists": "စာရင်းများ",
  "column.mutes": "မပေါ်အောင်ပိတ်ထားသောအသုံးပြုသူများ",
  "column.notifications": "အသိပေးချက်များ",
  "column.pins": "Pinned post",
  "column.public": "အားလုံးဖတ်နိုင်သောအချိန်ဇယား",
  "column_back_button.label": "နောက်သို့",
  "column_header.hide_settings": "ဆက်တင်များကို ဖျောက်ပါ။",
  "column_header.moveLeft_settings": "ကော်လံကို ဘယ်ဘက်သို့ ရွှေ့ပါ။",
  "column_header.moveRight_settings": "ကော်လံကို ညာဘက်သို့ ရွှေ့ပါ။",
  "column_header.pin": "ထိပ်တွင်တွဲထားမည်",
  "column_header.show_settings": "ဆက်တင်များကို ပြပါ။",
  "column_header.unpin": "မတွဲတော့ပါ",
  "community.column_settings.local_only": "ပြည်တွင်း၌သာ",
  "community.column_settings.media_only": "Media only",
  "community.column_settings.remote_only": "အဝေးမှသာ",
  "compose.language.change": "ဘာသာစကား ပြောင်းမည်",
  "compose.language.search": "ဘာသာစကားကိုရှာမည်",
  "compose.published.body": "ပို့စ်တင်ပြီးပါပြီ။",
  "compose.published.open": "ဖွင့်",
  "compose.saved.body": "ပို့စ် သိမ်းဆည်းပြီးပါပြီ။",
  "compose_form.direct_message_warning_learn_more": "ထပ်သိရှိလိုသည်",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "ဤပို့စ်သည် အများသူငှာမဟုတ်သောကြောင့် မည်သည့် hashtag အောက်တွင် ဖော်ပြမည်မဟုတ်ပါ။ အများသူငှာ ပို့စ်များကိုသာ hashtag ဖြင့် ရှာဖွေနိုင်သည်။",
  "compose_form.lock_disclaimer": "သင့်အကောင့်ကို {သော့ခတ်မထားပါ}။ သင့်နောက်လိုက်-သီးသန့်ပို့စ်များကို ကြည့်ရှုရန် မည်သူမဆို သင့်အား လိုက်ကြည့်နိုင်ပါသည်။",
  "compose_form.lock_disclaimer.lock": "သော့ခတ်ထားမယ်",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.poll.duration": "စစ်တမ်းကြာချိန်",
  "compose_form.poll.switch_to_multiple": "စစ်တမ်းတွင်တစ်ခုထပ်ပိုသောဆန္ဒပြုချက်လက်ခံမည်",
  "compose_form.poll.switch_to_single": "စစ်တမ်းတွင် တစ်ခုကိုသာရွေးချယ်ခွင့်ပြုမည်",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmation_modal.cancel": "ပယ်ဖျက်မည်",
  "confirmations.block.confirm": "ဘလော့မည်",
  "confirmations.delete.confirm": "ဖျက်မည်",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete_list.confirm": "ဖျက်မည်",
  "confirmations.delete_list.message": "ဖျက်ရန် သေချာပါသလား?",
  "confirmations.discard_edit_media.confirm": "ဖယ်ထုတ်ပါ",
  "confirmations.discard_edit_media.message": "သင်သည် မီဒီယာဖော်ပြချက် သို့မဟုတ် အစမ်းကြည့်ရှုခြင်းတွင် မသိမ်းဆည်းရသေးသော အပြောင်းအလဲများရှိသည်။ မည်သို့ပင်ဖြစ်စေ ဖျက်ပစ်မည်လား။",
  "confirmations.logout.confirm": "အကောင့်မှထွက်မည်",
  "confirmations.logout.message": "အကောင့်မှ ထွက်ရန် သေချာပါသလား?",
  "confirmations.mute.confirm": "ပိတ်ထားရန်",
  "confirmations.redraft.confirm": "ဖျက်ပြီး ပြန်လည်ရေးမည်။",
  "confirmations.redraft.message": "သင် ဒီပိုစ့်ကိုဖျက်ပြီး ပြန်တည်းဖြတ်မှာ သေချာပြီလား။ ကြယ်ပွင့်​တွေ နဲ့ ပြန်မျှ​ဝေမှု​တွေကိုဆုံးရှုံးမည်။မူရင်းပို့စ်ဆီကို ပြန်စာ​တွေမှာလည်း​ \nပိုစ့်ကို​တွေ့ရမည်မဟုတ်​တော့ပါ။.",
  "confirmations.unfollow.confirm": "စောင့်ကြည့်ခြင်းအား ပယ်ဖျက်မည်",
  "conversation.delete": "ဤစကားပြောဆိုမှုကို ဖျက်ပစ်မည်",
  "conversation.mark_as_read": "ဖတ်ပြီးသားအဖြစ်မှတ်ထားပါ",
  "conversation.open": "Conversation ကိုကြည့်မည်",
  "conversation.with": "{အမည်များ} ဖြင့်",
  "copy_icon_button.copied": "ကလစ်ဘုတ်သို့ ကူးပါ",
  "copypaste.copied": "ကူယူပြီးပါပြီ",
  "copypaste.copy_to_clipboard": "ကလစ်ဘုတ်သို့ ကူးပါ",
  "directory.federated": "သင် သိသော ဖက်ဒီမှ",
  "directory.local": "{domain} မှသာလျှင်\n",
  "directory.new_arrivals": "အသစ်ရောက်ရှိမှုများ",
  "directory.recently_active": "မကြာသေးခင်က ဖွင့်ထားသော",
  "disabled_account_banner.account_settings": "အကောင့်ဆက်တင်များ",
  "disabled_account_banner.text": "{disabledAccount} သည်လတ်တလောပိတ်ခံထားရသည်",
  "dismissable_banner.community_timeline": "အကောင့်များမှ လတ်တလောတင်ထားသည့်အများမြင်ပို့စ်များမှာ {domain} တွင် တင်ထားသောပို့စ်များဖြစ်သည်။",
  "dismissable_banner.dismiss": "ပယ်ရန်",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "ဒါမျိုးမြင်ရမှာပါ။",
  "emoji_button.activity": "လုပ်ဆောင်ချက်",
  "emoji_button.clear": "ရှင်းလင်းမည်",
  "emoji_button.custom": "စိတ်ကြိုက်",
  "emoji_button.flags": "Flags",
  "emoji_button.food": "အစားအသောက်",
  "emoji_button.label": "အီမိုဂျီထည့်ပါ",
  "emoji_button.nature": "သဘာဝ",
  "emoji_button.not_found": "ကိုက်ညီသော အီမိုဂျီများ ရှာမတွေ့ပါ",
  "emoji_button.objects": "Objects",
  "emoji_button.people": "လူများ",
  "emoji_button.recent": "မကြာခဏ အသုံးပြုသော",
  "emoji_button.search": "ရှာရန်...",
  "emoji_button.search_results": "ရှာဖွေမှု ရလဒ်များ",
  "emoji_button.symbols": "သင်္ကေတများ",
  "emoji_button.travel": "ခရီးသွားခြင်း နှင့် နေရာများ",
  "empty_column.account_suspended": "အကောင့်ရပ်ဆိုင်းထားသည်",
  "empty_column.account_timeline": "No posts found",
  "empty_column.account_unavailable": "ပရိုဖိုင် မရနိုင်ပါ",
  "empty_column.blocks": "ပိတ်ထားသောအကောင့်များမရှိသေးပါ",
  "empty_column.bookmarked_statuses": "သင့်တွင် မှတ်သားထားသော ပို့စ်များ မရှိသေးပါ။ တစ်ခုကို အမှတ်အသားပြုလိုက်ပါက ၎င်းကို ဤနေရာတွင် ပြထားပါမည်။",
  "empty_column.community": "ဒေသတွင်းစာမျက်နှာမှာ အလွတ်ဖြစ်နေသည်။ အများမြင်နိုင်ရန်အတွက် တစ်ခုခုရေးပါ။",
  "empty_column.direct": "သင့်တွင် သီးသန့်ဖော်ပြချက်များ မရှိသေးပါ။ ပေးပို့ခြင်း သို့မဟုတ် လက်ခံသောအခါ၊ ၎င်းသည် ဤနေရာတွင် ပေါ်လာလိမ့်မည်။",
  "empty_column.domain_blocks": "သင်ပိတ်ထားသော ဒိုမိန်းမရှိသေးပါ",
  "empty_column.explore_statuses": "အခုလောလောဆယ်တွင် ရေပန်းစားနေသောပို့စ်များ မရှိသေးပါ။ နောက်မှ ပြန်စစ်ဆေးပါရန်။",
  "empty_column.favourited_statuses": "သင့်တွင် favorite ပို့စ်များ မရှိသေးပါ။ သင် favorite ရွေးချယ်လိုက်ပါက ဤနေရာတွင်ပေါ်လာပါမည်။",
  "empty_column.favourites": "ဤပို့စ်ကို favorite ပြုလုပ်ထားသူ မရှိသေးပါ။ တစ်စုံတစ်ယောက် favorite ပြုလုပ်လိုက်ပါက ဤနေရာတွင် ပြပါမည်။",
  "empty_column.follow_requests": "သင့်တွင် စောင့်ကြည့်ရန် တောင်းဆိုမှုများ မရှိသေးပါ။ သင်လက်ခံရရှိပါက ၎င်းကို ဤနေရာတွင် ပြထားပါမည်။",
  "empty_column.followed_tags": "သင်သည် မည်သည့် hashtag ကိုမျှ စောင့်မကြည့်ရသေးပါ။ စောင့်ကြည့်ပါက ဤနေရာတွင် ပြပေးပါမည်။",
  "empty_column.hashtag": "ဤ hashtag တွင် မည်သည့်အရာမျှ မရှိသေးပါ။",
  "empty_column.home": "သင့်ပင်မစာမျက်နှာမှာ အလွတ်ဖြစ်နေပါသည်။ ဖြည့်ရန်အတွက် လူများကို စောင့်ကြည့်ပါ {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "empty_column.mutes": "ပိတ်ထားသောအကောင့်များမရှိသေးပါ",
  "empty_column.notifications": "သတိပေးချက်မရှိသေးပါ။ သတိပေးချက်အသစ်ရှိလျှင် ဤနေရာတွင်ကြည့်ရှုနိုင်သည်",
  "empty_column.public": "ဤနေရာတွင် မည်သည့်အရာမျှမရှိပါ။ တစ်ခုခုရေးပါ သို့မဟုတ် ဖြည့်စွက်ရန်အတွက် အခြားဆာဗာ အသုံးပြုသူများကို စောင့်ကြည့်ပါ။",
  "error.unexpected_crash.explanation": " ကျွန်ုပ်တို့၏ကုဒ်တွင် ချွတ်ယွင်းချက်တစ်ခု သို့မဟုတ် ဘရောက်ဆာနှင့် အဆင်မပြေမှုတို့ကြောင့် ဤစာမျက်နှာကို မှန်ကန်စွာ မပြသနိုင်ပါ။",
  "error.unexpected_crash.explanation_addons": "ဤစာမျက်နှာကို မှန်ကန်စွာ မပြသနိုင်ခဲ့ပါ။ ဤအမှားသည် Browser add-on ထည့်သွင်းထားမှုများ သို့မဟုတ် အလိုအလျောက် ဘာသာပြန်ကိရိယာများကြောင့် ဖြစ်နိုင်သည်။",
  "error.unexpected_crash.next_steps": "စာမျက်နှာကို ပြန်လည်စတင်ကြည့်ပါ။ ၎င်းမှာ အကူအညီမဖြစ်ပါက သင်သည် အခြား Browser သို့မဟုတ် မူရင်းအက်ပ်မှတစ်ဆင့် Mastodon ကို ဆက်လက်အသုံးပြုနိုင်ပါမည်။",
  "error.unexpected_crash.next_steps_addons": "၎င်းတို့ကို ပိတ်ပြီး စာမျက်နှာကို ပြန်လည်စတင်ကြည့်ပါ။ အဆင်မပြေပါက အခြားဘရောက်ဆာ သို့မဟုတ် မူရင်းအက်ပ်မှတစ်ဆင့် Mastodon ကို ဆက်ပြီးအသုံးပြုနိုင်ပါမည်။",
  "errors.unexpected_crash.copy_stacktrace": "stacktrace ကို ကလစ်ဘုတ်သို့ ကူးယူပါ",
  "errors.unexpected_crash.report_issue": "အဆင်မပြေမှုကို တိုင်ကြားရန်",
  "explore.suggested_follows": "လူများ",
  "explore.trending_links": "သတင်းများ",
  "explore.trending_statuses": "ပို့စ်တင်မယ်",
  "explore.trending_tags": "ဟက်ရှ်တက်များ",
  "filter_modal.added.context_mismatch_explanation": "ဤစစ်ထုတ်မှု အမျိုးအစားသည် ဤပို့စ်ကို သင်ဝင်ရောက်ခဲ့ခြင်းနှင့် မသက်ဆိုင်ပါ။ ပို့စ်ကို စစ်ထုတ်လိုပါက စစ်ထုတ်မှုကို ပြင်ဆင်ရမည်ဖြစ်သည်။",
  "filter_modal.added.context_mismatch_title": "အကြောင်းအရာ မကိုက်ညီပါ။",
  "filter_modal.added.expired_explanation": "ဤစစ်ထုတ်မှုအမျိုးအစားမှာ သက်တမ်းကုန်သွားပါပြီ။ အသုံးပြုလိုပါက သက်တမ်းကုန်ဆုံးရက်ကို ပြောင်းလဲနိုင်ပါသည်။",
  "filter_modal.added.expired_title": "သက်တမ်းကုန်နေသော စစ်ထုတ်မှု။",
  "filter_modal.added.review_and_configure": "ဤစစ်ထုတ်မှုအမျိုးအစားကို ပြန်လည်သုံးသပ်ပြီး ထပ်မံပြင်ဆင်သတ်မှတ်ရန်၊ {settings_link} သို့ သွားပါ။",
  "filter_modal.added.review_and_configure_title": "စစ်ထုတ်မှု သတ်မှတ်ချက်များ",
  "filter_modal.added.settings_link": "သတ်မှတ်ချက်များစာမျက်နှာ",
  "filter_modal.added.short_explanation": "ဤပို့စ်ကို အောက်ပါ စစ်ထုတ်မှုအမျိုးအစားတွင် ပေါင်းထည့်ထားပါသည် - {title}။",
  "filter_modal.added.title": "စစ်ထုတ်မှု ထည့်သွင်းပြီးပါပြီ။",
  "filter_modal.select_filter.context_mismatch": "ဤအကြောင်းအရာနှင့် မသက်ဆိုင်ပါ",
  "filter_modal.select_filter.expired": "သက်တမ်းကုန်သွားပါပြီ",
  "filter_modal.select_filter.prompt_new": "အမျိုးအစားအသစ် - {name}",
  "filter_modal.select_filter.search": "ရှာရန် သို့မဟုတ် ဖန်တီးရန်",
  "filter_modal.select_filter.subtitle": "ရှိပြီးသားအမျိုးအစားကို သုံးပါ သို့မဟုတ် အသစ်တစ်ခု ဖန်တီးပါ",
  "filter_modal.select_filter.title": "ဤပို့စ်ကို စစ်ထုတ်ပါ",
  "filter_modal.title.status": "ပို့စ်တစ်ခု စစ်ထုတ်ပါ",
  "firehose.all": "အားလုံး",
  "firehose.local": "ဤဆာဗာ",
  "firehose.remote": "အခြားဆာဗာများ",
  "follow_request.authorize": "လုပ်ပိုင်ခွင့်",
  "follow_request.reject": "ဖယ်ရှားပါ",
  "follow_requests.unlocked_explanation": "သင့်အကောင့်ကို လော့ခ်ချမထားသော်လည်း၊ {domain} ဝန်ထမ်းများသည် ဤအကောင့်များမှ လိုက်နာရန်တောင်းဆိုမှုများကို ကိုယ်တိုင်ပြန်လည်စစ်ဆေးလိုမည်ဟု ထင်မြင်ယူဆပါသည်။",
  "followed_tags": "Hashtag ကို စောင့်ကြည့်ပါမည်",
  "footer.about": "အကြောင်း",
  "footer.directory": "ပရိုဖိုင်များလမ်းညွှန်",
  "footer.get_app": "အက်ပ်ကို ရယူပါ",
  "footer.keyboard_shortcuts": "ကီးဘုတ်အမြန်ခလုတ်များ",
  "footer.privacy_policy": "ကိုယ်ရေးအချက်အလက်မူဝါဒ",
  "footer.source_code": "မူရင်းကုဒ်အားကြည့်ရှုမည်",
  "footer.status": "အခြေအနေ",
  "generic.saved": "သိမ်းဆည်းထားပြီး",
  "getting_started.heading": "စတင်မည်",
  "hashtag.column_header.tag_mode.all": "နှင့် {additional}",
  "hashtag.column_header.tag_mode.any": "သို့မဟုတ် {additional}",
  "hashtag.column_header.tag_mode.none": "မပါဘဲ {additional}",
  "hashtag.column_settings.select.no_options_message": "အကြံပြုချက်မတွေ့ပါ",
  "hashtag.column_settings.select.placeholder": "hashtag သို့ ဝင်ရောက်နေခြင်း...",
  "hashtag.column_settings.tag_mode.all": "ဤအရာအားလုံး",
  "hashtag.column_settings.tag_mode.any": "ဤအရာထဲမှ တစ်ခု",
  "hashtag.column_settings.tag_mode.none": "တစ်ခုမှ မဟုတ်ပါ။",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} post} other {{counter} posts}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} post} other {{counter} posts}} today",
  "hashtag.follow": "Hashtag ကို စောင့်ကြည့်မယ်",
  "hashtag.unfollow": "Hashtag ကို မစောင့်ကြည့်ပါ",
  "hashtags.and_other": "{count, plural, other {# more}} နှင့်",
  "home.column_settings.show_reblogs": "Boost များကို ပြပါ",
  "home.column_settings.show_replies": "ပြန်စာများကို ပြပါ",
  "home.hide_announcements": "ကြေညာချက်များကို ဖျောက်ပါ",
  "home.pending_critical_update.body": "သင့် Mastodon ဆာဗာ အမြန်ဆုံး အပ်ဒိတ်လုပ်ပါ။",
  "home.pending_critical_update.link": "အပ်ဒိတ်များကြည့်ရန်",
  "home.pending_critical_update.title": "အရေးကြီးသည့် လုံခြုံရေးအပ်ဒိတ် ရနိုင်ပါမည်။",
  "home.show_announcements": "ကြေညာချက်များကို ပြပါ",
  "interaction_modal.on_another_server": "တခြားဆာဗာပေါ်တွင်",
  "interaction_modal.on_this_server": "ဤဆာဗာတွင်",
  "intervals.full.days": "{number, plural, one {# day} other {# days}}",
  "intervals.full.hours": "{number, plural, one {# hour} other {# hours}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minutes}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "ဖော်ပြချက်",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.favourite": "Favorite ပို့စ်",
  "keyboard_shortcuts.favourites": " favorite များ စာရင်းကို ဖွင့်ပါ",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "သော့ချက်",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned posts list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new post",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "ပိတ်ပါ",
  "lightbox.next": "ရှေ့သို့",
  "lightbox.previous": "ရှေ့သို့",
  "limited_account_hint.action": "ဘာပဲဖြစ်ဖြစ် ပရိုဖိုင်ကို ပြပါ",
  "limited_account_hint.title": "ဤပရိုဖိုင်ကို {domain} ၏ စိစစ်သူများမှ ဖျောက်ထားသည်။",
  "link_preview.author": "{name} ဖြင့်",
  "lists.delete": "စာရင်းကိုဖျက်ပါ",
  "lists.edit": "စာရင်းကိုပြင်ဆင်ပါ",
  "lists.replies_policy.followed": "မည်သည့်စောင့်ကြည့်သူမဆို",
  "lists.replies_policy.list": "စာရင်းထဲမှ အဖွဲ့ဝင်များ",
  "lists.replies_policy.none": "တစ်ယောက်မှမရှိပါ",
  "load_pending": "{count, plural, one {# new item} other {# new items}}",
  "loading_indicator.label": "လုပ်ဆောင်နေသည်…",
  "moved_to_account_banner.text": "{movedToAccount} အကောင့်သို့ပြောင်းလဲထားသဖြင့် {disabledAccount} အကောင့်မှာပိတ်ထားသည်",
  "navigation_bar.about": "အကြောင်း",
  "navigation_bar.advanced_interface": "အဆင့်မြင့်ဝဘ်ပုံစံ ဖွင့်ပါ",
  "navigation_bar.blocks": "ဘလော့ထားသောအကောင့်များ",
  "navigation_bar.bookmarks": "မှတ်ထားသည်များ",
  "navigation_bar.direct": "သီးသန့်ဖော်ပြချက်များ",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.favourites": "Favorites",
  "navigation_bar.filters": "စကားလုံးများ ပိတ်ထားပါ",
  "navigation_bar.follow_requests": "စောင့်ကြည့်ရန် တောင်းဆိုမှုများ",
  "navigation_bar.followed_tags": "Hashtag ကို စောင့်ကြည့်မယ်",
  "navigation_bar.follows_and_followers": "စောင့်ကြည့်သူများနှင့် စောင့်ကြည့်စာရင်း",
  "navigation_bar.lists": "စာရင်းများ",
  "navigation_bar.logout": "ထွက်မယ်",
  "navigation_bar.mutes": "အသုံးပြုသူများကို ပိတ်ထားပါ",
  "navigation_bar.opened_in_classic_interface": "ပို့စ်များ၊ အကောင့်များနှင့် အခြားသီးခြားစာမျက်နှာများကို classic ဝဘ်အင်တာဖေ့စ်တွင် ဖွင့်ထားသည်။",
  "navigation_bar.preferences": "စိတ်ကြိုက်သတ်မှတ်ချက်များ",
  "navigation_bar.search": "ရှာရန်",
  "not_signed_in_indicator.not_signed_in": "ဤရင်းမြစ်သို့ ဝင်ရောက်ရန်အတွက် သင်သည် အကောင့်ဝင်ရန် လိုအပ်ပါသည်။",
  "notification.admin.report": "{name} က {target} ကို တိုင်ကြားခဲ့သည်",
  "notification.admin.sign_up": "{name} က အကောင့်ဖွင့်ထားသည်",
  "notification.favourite": "{name} က သင့်ပို့စ်ကို နှစ်သက်ခဲ့သည်",
  "notification.follow": "{name} က သင့်ကို စောင့်ကြည့်ခဲ့သည်",
  "notification.follow_request": "{name} က သင့်ကို စောင့်ကြည့်ရန် တောင်းဆိုထားသည်",
  "notification.own_poll": "စစ်တမ်းကောက်မှု ပြီးဆုံးပါပြီ",
  "notification.reblog": "{name} boosted your status",
  "notification.status": "{name} က အခုလေးတင် ပို့စ်တင်လိုက်ပါပြီ",
  "notification.update": "{name} က ပို့စ်တစ်ခုကို ပြင်ဆင်ခဲ့သည်",
  "notifications.clear": "အသိပေးချက်များအား ရှင်းလင်းပါ",
  "notifications.clear_confirmation": "သတိပေးချက်အားလုံးကို အပြီးတိုင်ဖယ်ရှားမည်",
  "notifications.column_settings.admin.report": "တိုင်ကြားစာအသစ်များ -",
  "notifications.column_settings.admin.sign_up": "အကောင့်အသစ်များ -",
  "notifications.column_settings.alert": "Desktop သတိပေးချက်များ",
  "notifications.column_settings.favourite": "Favorites:",
  "notifications.column_settings.follow": "စောင့်ကြည့်သူအသစ်များ -",
  "notifications.column_settings.follow_request": "စောင့်ကြည့်ရန် တောင်းဆိုမှုအသစ်များ -",
  "notifications.column_settings.mention": "ဖော်ပြချက်များ -",
  "notifications.column_settings.poll": "စစ်တမ်းရလဒ်",
  "notifications.column_settings.push": "အသိပေးချက်များအား ရအောင်ပို့ခြင်း",
  "notifications.column_settings.reblog": "Boosts -",
  "notifications.column_settings.show": "ကော်လံတွင်ပြပါ",
  "notifications.column_settings.sound": "အသံဖွင့်မည်",
  "notifications.column_settings.status": "ပို့စ်အသစ်များ -",
  "notifications.column_settings.unread_notifications.category": "မဖတ်ရသေးသောအသိပေးချက်များ -",
  "notifications.column_settings.unread_notifications.highlight": "မဖတ်ရသေးသော အသိပေးချက်များကို ဖော်ပြပါ",
  "notifications.column_settings.update": "ပြင်ဆင်ထားမှုများ -",
  "notifications.filter.all": "အားလုံး",
  "notifications.filter.boosts": "အားပေးမည်",
  "notifications.filter.favourites": "Favorites",
  "notifications.filter.follows": "စောင့်ကြည့်မယ်",
  "notifications.filter.mentions": " မန်းရှင်းမည်",
  "notifications.filter.polls": "စစ်တမ်းရလဒ်",
  "notifications.filter.statuses": "သင်စောင့်ကြည့်သူများထံမှ အပ်ဒိတ်များ",
  "notifications.grant_permission": "ခွင့်ပြုချက်ပေးမည်",
  "notifications.group": "အသိပေးချက်များ {count} ခု",
  "notifications.mark_as_read": "အသိပေးချက်တိုင်းကို ဖတ်ပြီးကြောင်း အမှတ်အသားပြုပါ",
  "notifications.permission_denied": "ဘရောက်ဆာခွင့်ပြုချက်များ တောင်းဆိုမှုအား ငြင်းခဲ့သောကြောင့် ဒက်စ်တော့ အသိပေးချက်များကို မရရှိနိုင်ပါ",
  "notifications.permission_denied_alert": "ဘရောက်ဆာခွင့်ပြုချက်ကို ငြင်းပယ်ခဲ့သောကြောင့် ဒက်စ်တော့ အသိပေးချက်များကို ဖွင့်၍မရပါ",
  "notifications.permission_required": "လိုအပ်သောခွင့်ပြုချက်ကို မပေးထားသောကြောင့် ဒက်စ်တော့ အသိပေးချက်များကို မရရှိနိုင်ပါ။",
  "notifications_permission_banner.enable": "ဒက်စ်တော့ အသိပေးချက်များကို ဖွင့်ပါ",
  "notifications_permission_banner.how_to_control": "Mastodon မဖွင့်သည့်အခါ အကြောင်းကြားချက်များကို လက်ခံရယူရန်၊ ဒက်စ်တော့ အသိပေးချက်များကို ဖွင့်ပါ။ ၎င်းတို့ကို ဖွင့်ပြီးသည်နှင့် ၎င်းတို့ကို ဖွင့်ပြီးသည်နှင့် အထက် {icon} ခလုတ်မှ ဒက်စ်တော့ အသိပေးချက်များကို ထုတ်ပေးသည့် အပြန်အလှန်တုံ့ပြန်မှု အမျိုးအစားများကို သင် အတိအကျ ထိန်းချုပ်နိုင်သည်။",
  "notifications_permission_banner.title": "လက်လွတ်မခံပါနှင့်",
  "onboarding.follows.empty": "ယခုအချိန် မည်သည့်ရလဒ်ကိုမျှ မပြသနိုင်ပါ။ လူများကိုစောင့်ကြည့်ရန်အတွက် Explore စာမျက်နှာကို အသုံးပြု၍ စမ်းကြည့်နိုင်သည် သို့မဟုတ် နောက်မှ ထပ်စမ်းကြည့်ပါ။",
  "onboarding.profile.discoverable": "ပရိုဖိုင် ရှာဖွေနိုင်ပါမည်",
  "onboarding.profile.display_name": "ဖော်ပြမည့်အမည်",
  "onboarding.profile.display_name_hint": "သင့်အမည်အပြည့်အစုံ သို့မဟုတ် သင့်အမည်ပြောင်။",
  "onboarding.profile.note": "ကိုယ်ရေးအကျဉ်း",
  "onboarding.profile.title": "ပရိုဖိုင်စနစ် ထည့်သွင်းခြင်း",
  "onboarding.profile.upload_avatar": "ပရိုဖိုင်ပုံ အပ်လုဒ်လုပ်ပါ",
  "password_confirmation.exceeds_maxlength": "စကားဝှက်အတည်ပြုခြင်းတွင် အများဆုံးစကားဝှက်အရှည်ထက် ကျော်လွန်နေပါသည်",
  "password_confirmation.mismatching": "စကားဝှက်အတည်ပြုချက်မှာ မကိုက်ညီပါ",
  "picture_in_picture.restore": "ပြန်ထားပါ",
  "poll.closed": "ပိတ်သွားပြီ",
  "poll.refresh": "ပြန်ဖွင့်မည်",
  "poll.reveal": "ရလဒ်များကိုကြည့်ပါ",
  "poll.total_people": "{count, plural, one {# person} other {# people}}\n",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "မဲပေးမည်",
  "poll.voted": "သင်ဤအဖြေကိုမဲပေးခဲ့သည်",
  "poll.votes": "{votes, plural, one {# vote} other {# votes}}",
  "poll_button.add_poll": "စစ်တမ်းကောက်မည်",
  "poll_button.remove_poll": "စစ်တမ်းပယ်ဖျက်မည်",
  "privacy.change": "Adjust status privacy",
  "privacy.public.short": "အများကိုပြမည်",
  "privacy_policy.last_updated": "နောက်ဆုံး ပြင်ဆင်ခဲ့သည့်ရက်စွဲ {date}",
  "privacy_policy.title": "ကိုယ်ရေးအချက်အလက်မူဝါဒ",
  "recommended": "အကြံပြုသည်",
  "refresh": "ပြန်လည်စတင်ပါ",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# day} other {# days}} ago",
  "relative_time.full.hours": "{number, plural, one {# hour} other {# hours}} ago",
  "relative_time.full.just_now": "အခုလေးတင်",
  "relative_time.full.minutes": "{number, plural, one {# minute} other {# minutes}} ago",
  "relative_time.full.seconds": "{number, plural, one {# second} other {# seconds}} ago",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "ယခု",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "ယနေ့",
  "reply_indicator.cancel": "ပယ်ဖျက်မည်",
  "report.block": "ဘလော့မည်",
  "report.block_explanation": "၎င်းတို့ရဲ့ ပို့စ်တွေကို မြင်ရမှာမဟုတ်ဘူး။ သင့်ပို့စ်များကို မမြင်နိုင်သလို သင့်ကို စောင့်ကြည့်၍ရမည်လည်းမဟုတ်ပါ။ ၎င်းတို့ကို ပိတ်ပင်ထားပါသည်။",
  "report.categories.legal": "တရားဝင်",
  "report.categories.other": "အခြား",
  "report.categories.spam": "ပြင်ပစာများ",
  "report.categories.violation": "ဤစာတွင် သတ်မှတ်ထားသောစည်းကမ်းများကို ဖောက်ဖျက်သောအကြောင်းအရာပါဝင်နေသည်",
  "report.category.subtitle": "အကိုက်ညီဆုံးကိုရွေးချယ်ပါ",
  "report.category.title": "ဤ {type} တွင် ဘာဖြစ်နေသည်ကို ပြောပြပါ",
  "report.category.title_account": "ကိုယ်ရေးမှတ်တမ်း",
  "report.category.title_status": "ပို့စ်",
  "report.close": "ပြီးပြီ",
  "report.comment.title": "မိမိထင်မြင်ယူဆချက်များကိုဖော်ပြပေးပါ",
  "report.forward": "{target} သို့တစ်ဆင့်ပို့ပေးမည်",
  "report.forward_hint": "ဤအကောင့်မှာတစ်ခြားဆာဗာမှဖြစ်သည်။ အမည်မသိတိုင်းကြားချက်ဖွင့်လိုပါသလား?",
  "report.mute": "ပိတ်ထားရန်",
  "report.mute_explanation": "၎င်းတို့၏ပို့စ်များကို သင်မြင်ရမည်မဟုတ်ပါ။ ၎င်းတို့မှာ သင့်ကို စောင့်ကြည့်၍ ပို့စ်များကို မြင်နိုင်ဆဲဖြစ်ပြီး ၎င်းတို့ကို အသံပိတ်ထားကြောင်း သိမည်မဟုတ်ပါ။\n",
  "report.next": "ရှေ့သို့",
  "report.placeholder": "Type or paste additional comments",
  "report.reasons.dislike": "မကြိုက်ပါ",
  "report.reasons.dislike_description": "ပိုမိုမြင်လိုသည်ရှိပါသလား",
  "report.reasons.legal": "တရားမဝင်ပါ",
  "report.reasons.legal_description": "ဆာဗာဥပဒေကို ချိုးဖောက်သည်",
  "report.reasons.other": "တစ်ခုခုဖြစ်နေသည်",
  "report.reasons.other_description": "ဤအချက်မှာ အခြားအမျိုးအစားများနှင့် မကိုက်ညီပါ။",
  "report.reasons.spam": "၎င်းမှာ Spam ဖြစ်သည်",
  "report.reasons.spam_description": "အန္တရာယ်ရှိသော လင့်ခ်များ၊ အတုအယောင်များ သို့မဟုတ် ထပ်တလဲလဲ ပြန်ကြားမှုများ",
  "report.reasons.violation": "၎င်းမှာ ဆာဗာစည်းမျဉ်းများကို ချိုးဖောက်ထားသည်",
  "report.reasons.violation_description": "သတ်မှတ်ထားသော စည်းကမ်းများကို ချိုးဖောက်ထားကြောင်း သင် သိရှိထားသည်။",
  "report.rules.subtitle": "သက်ဆိုင်သမျှကို ရွေးပါ",
  "report.rules.title": "မည်သည့်စည်းကမ်းများကို ချိုးဖောက်ထားပါသလဲ။",
  "report.statuses.subtitle": "သက်ဆိုင်သမျှကို ရွေးပါ",
  "report.statuses.title": "ဤတိုင်ကြားစာကို အရန်ကူးထားသည့် ပို့စ်များ ရှိပါသလား။",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report.thanks.take_action": "ဤသည်မှာ Mastodon တွင် သင်မြင်ရသည့်အရာများ ထိန်းချုပ်ရန်အတွက် ရွေးချယ်ရမည့်နေရာဖြစ်သည် -",
  "report.thanks.take_action_actionable": "၎င်းကို ကျွန်ုပ်တို့ သုံးသပ်နေချိန်တွင် သင်သည် @{name} ကို အရေးယူနိုင်သည် -",
  "report.thanks.title": "ဒါကို မမြင်ချင်ဘူးလား။",
  "report.thanks.title_actionable": "တိုင်ကြားခြင်းအတွက် ကျေးဇူးတင်ပါသည်၊ ဤအရာကို ကျွန်ုပ်တို့ စစ်ဆေးပါမည်။",
  "report.unfollow": "@{name} ကို မစောင့်ကြည့်တော့ပါ",
  "report.unfollow_explanation": "သင် ဤအကောင့်ကို စောင့်ကြည့်နေသည်။ သင့်ပင်မစာမျက်နှာတွင် ၎င်းတို့၏ပို့စ်များကို ထပ်ပြီးမတွေ့ချင်တော့ပါက စောင့်ကြည့်ခြင်းကို ရပ်တန့်နိုင်ပါသည်။",
  "report_notification.attached_statuses": "{count, plural, one {{count} post} other {{count} posts}} attached",
  "report_notification.categories.legal": "တရားဝင်",
  "report_notification.categories.other": "အခြား",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "စည်းကမ်းဖောက်ဖျက်ခြင်း",
  "report_notification.open": "အစီရင်ခံစာကိုဖွင့်ပါ",
  "search.no_recent_searches": "လတ်တလောရှာဖွေမှုများမရှိပါ။",
  "search.placeholder": "ရှာဖွေရန်",
  "search.quick_action.account_search": "{x} နှင့် ကိုက်ညီသော ပရိုဖိုင်များ",
  "search.quick_action.go_to_account": "ပရိုဖိုင် {x} သို့သွားမည်",
  "search.quick_action.go_to_hashtag": "hashtag {x} သို့သွားမည်",
  "search.quick_action.open_url": "Mastodon တွင် URL ကိုဖွင့်မည်",
  "search.quick_action.status_search": "{x} နှင့် ကိုက်ညီသော ပို့စ်များ",
  "search.search_or_paste": "URL ရိုက်ထည့်ပါ သို့မဟုတ် ရှာဖွေပါ",
  "search_popout.full_text_search_disabled_message": "{domain} တွင် မရနိုင်ပါ။",
  "search_popout.full_text_search_logged_out_message": "အကောင့်ဝင်ထားမှသာ ရနိုင်သည်။",
  "search_popout.language_code": "ISO ဘာသာစကားကုဒ်",
  "search_popout.options": "ရွေးချယ်ထားသည်များ ရှာဖွေရန်",
  "search_popout.quick_actions": "အမြန်လုပ်ဆောင်မှုများ",
  "search_popout.recent": "လတ်တလော ရှာဖွေမှုများ",
  "search_popout.specific_date": "သီးခြားရက်စွဲ",
  "search_popout.user": "အသုံးပြုသူ",
  "search_results.accounts": "စာမျက်နှာ",
  "search_results.all": "အားလုံး",
  "search_results.hashtags": "ဟက်ရှ်တက်များ",
  "search_results.see_all": "အားလုံးကို ကြည့်ရန်",
  "search_results.statuses": "ပို့စ်တင်မယ်",
  "server_banner.about_active_users": "ပြီးခဲ့သည့် ရက်ပေါင်း ၃၀ အတွင်း ဤဆာဗာကို အသုံးပြုသူများ (လအလိုက် လက်ရှိအသုံးပြုသူများ)",
  "server_banner.active_users": "လက်ရှိအသုံးပြုသူများ",
  "server_banner.administered_by": "မှ စီမံခန့်ခွဲသည် -",
  "server_banner.server_stats": "ဆာဗာအား လက်ရှိအသုံးပြုသူများ -",
  "sign_in_banner.create_account": "အကောင့်ဖန်တီးမည်",
  "sign_in_banner.sign_in": "အကောင့်ဝင်မည်",
  "sign_in_banner.sso_redirect": "အကောင့်ဝင်ပါ သို့မဟုတ် မှတ်ပုံတင်ပါ",
  "status.admin_account": "@{name} အတွက် စိစစ်ခြင်းကြားခံနယ်ကို ဖွင့်ပါ",
  "status.admin_domain": "{domain} အတွက် စိစစ်ခြင်းကြားခံနယ်ကို ဖွင့်ပါ",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "@{name} ကိုဘလော့မည်",
  "status.bookmark": "မှတ်ထားသည်များ",
  "status.cancel_reblog_private": "Unboost",
  "status.cannot_reblog": "ဤပို့စ်ကို Boost ၍ မရပါ",
  "status.copy": "Copy link to status",
  "status.delete": "ဖျက်ရန်",
  "status.detailed_status": "အသေးစိတ်စကားပြောဆိုမှုမြင်ကွင်း",
  "status.direct": "@{name} ကို သီးသန့်ဖော်ပြမည်\n",
  "status.direct_indicator": "သီးသန့်ဖော်ပြခြင်း။",
  "status.edit": "ပြင်ဆင်ရန်",
  "status.edited_x_times": "{count, plural, one {{count} time} other {{count} times}} ပြင်ဆင်ခဲ့သည်",
  "status.favourite": "Favorite",
  "status.filter": "ဤပို့စ်ကို စစ်ထုတ်ပါ",
  "status.history.created": "{name} က {date} က ဖန်တီးခဲ့သည်",
  "status.history.edited": "{name} က {date} က ပြင်ဆင်ခဲ့သည်",
  "status.load_more": "ပို၍ဆောင်ရွက်ပါ",
  "status.media.open": "ဖွင့်ရန်နှိပ်ပါ",
  "status.media.show": "ပြရန်နှိပ်ပါ",
  "status.media_hidden": "မီဒီယာကို ဖျောက်ထားပါ",
  "status.mention": "@{name} ကို ဖော်ပြထားသည်",
  "status.more": "နောက်ထပ်",
  "status.mute": "@{name} ကို ပိတ်ထားရန်",
  "status.mute_conversation": "စကားဝိုင်းကို ပိတ်ထားရန်",
  "status.open": "ပို့စ်ကိုချဲ့ထွင်မည်",
  "status.pin": "ပရိုဖိုင်တွင် ပင်ထားပါ",
  "status.read_more": "ပိုမိုဖတ်ရှုရန်",
  "status.reblog": "Boost",
  "status.reblogged_by": "{name} က Boost လုပ်ထားသည်",
  "status.reblogs.empty": "ဤပို့စ်ကို မည်သူမှ Boost လုပ်ထားခြင်းမရှိသေးပါ။ တစ်ယောက်ယောက်မှ Boost လုပ်ပါက ဤနေရာတွင်ပေါ်လာပါမည်။",
  "status.redraft": "ဖျက်ပြီး ပြန်ရေးပါ",
  "status.remove_bookmark": "မှတ်ထားသည်များကို ဖယ်ရှားပါ",
  "status.replied_to": "{name} ကို စာပြန်ခဲ့သည်",
  "status.reply": "စာပြန်ရန်",
  "status.replyAll": "thread သို့ စာပြန်ပါ",
  "status.report": "@{name} ကို တိုင်ကြားရန်",
  "status.sensitive_warning": "သတိထားရသော အကြောင်းအရာ",
  "status.share": "မျှဝေ",
  "status.show_less_all": "အားလုံးအတွက် အနည်းငယ်သာ ပြပါ",
  "status.show_more_all": "အားလုံးအတွက် ပိုပြပါ",
  "status.show_original": "မူရင်းပြပါ",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {{attachmentCount} attachments}}",
  "status.translate": "ဘာသာပြန်ပါ",
  "status.translated_from_with": "{provider} ကို အသုံးပြု၍ {lang} မှ ဘာသာပြန်ထားသည်",
  "status.uncached_media_warning": "အစမ်းကြည့်ရှုခြင်း မရနိုင်ပါ",
  "status.unmute_conversation": "စကားဝိုင်းကို ပိတ်ထားရန်",
  "status.unpin": "ပရိုဖိုင်မှ ပင်ဖြုတ်ပါ။",
  "subscribed_languages.lead": "ပြောင်းလဲပြီးနောက် ရွေးချယ်ထားသော ဘာသာစကားများ၏ ပို့စ်များကိုသာ သင့် ပင်မစာမျက်နှာနှင့် စာရင်းစာမျက်နှာတွင်သာ ပေါ်လာမည်ဖြစ်ပါသည်။ ဘာသာစကားအားလုံး၏ ပို့စ်များအား ကြည့်ရှုလိုပါက အပြောင်းအလဲမပြုလုပ်ပါနှင့်။",
  "subscribed_languages.save": "ပြောင်းလဲမှုများကို သိမ်းဆည်းပါ",
  "subscribed_languages.target": "{target} အတွက် စာရင်းသွင်းထားသော ဘာသာစကားများကို ပြောင်းပါ",
  "tabs_bar.home": "ပင်မစာမျက်နှာ",
  "tabs_bar.notifications": "အသိပေးချက်များ",
  "time_remaining.days": "{number, plural, one {# day} other {# days}} left",
  "time_remaining.hours": "{number, plural, one {# hour} other {# hours}} left",
  "time_remaining.minutes": "{number, plural, one {# minute} other {# minutes}} left",
  "time_remaining.moments": "အခိုက်အတန့်များ ကျန်ရှိနေသေးသည်",
  "time_remaining.seconds": "{number, plural, one {# second} other {# seconds}} left",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {{days} days}}",
  "trends.trending_now": "လက်ရှိခေတ်စားနေသော ပို့စ်များ",
  "ui.beforeunload": "Mastodon မှ ထွက်ခွာပါက သင့်မူကြမ်း ဆုံးရှုံးသွားပါမည်။",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "ပို့စ်တင်ရန် ဆွဲချလိုက်ပါ",
  "upload_button.label": "ပုံများ၊ ဗီဒီယို သို့မဟုတ် အသံဖိုင်တစ်ခု ထည့်ပါ",
  "upload_error.limit": "ဖိုင်အများဆုံးတင်နိုင်မည့်ကန့်သတ်ချက်ကို ကျော်သွားပါပြီ။",
  "upload_error.poll": "စစ်တမ်းနှင့်အတူဖိုင်များတင်ခွင့်မပြုပါ",
  "upload_form.edit": "ပြင်ရန်",
  "upload_progress.label": "တင်နေသည်...",
  "upload_progress.processing": "လုပ်ဆောင်နေသည်…",
  "username.taken": "ထိုအသုံးပြုသူအမည်မှာ အသုံးပြုထားပြီးဖြစ်ပါသည်။ နောက်တစ်ခု စမ်းကြည့်ပါ",
  "video.close": "ဗီဒီယိုကို ပိတ်ပါ",
  "video.download": "ဖိုင်ကို ဒေါင်းလုဒ်လုပ်ပါ",
  "video.exit_fullscreen": "မျက်နှာပြင်အပြည့်မှ ထွက်ပါ",
  "video.expand": "ဗီဒီယိုကို ချဲ့ပါ",
  "video.fullscreen": "မျက်နှာပြင်အပြည့်",
  "video.hide": "ဗီဒီယိုကို ဖျောက်ပါ",
  "video.pause": "ခဏရပ်ပါ",
  "video.play": "ဖွင့်ပါ"
}
